// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 314 ? "b07aca9d" : chunkId) + "." + {"314":"2a8cd548451682c8","382":"5df8e89420ea28c0"}[chunkId] + ".js";
};